@if (isLoading()) {
  <div class="loadingPage">
    <div class="loading-page-content-section">
      <div class="loading-page-anim-section">
        <span class="x-1"></span>
        <span class="x-2"></span>
        <span class="x-3"></span>
        <span class="x-4"></span>
        <!-- <span class="x-5"></span> -->
      </div>
      <p>Preparing your workspace…</p>
    </div>
  </div>
}

@if (!isLoading() && isLoggedIn()) {
  @if (!isFloatingRoute()) {
    <div class="main-app-section">
      <app-reminders-marquee class="app-shell-bar" />
      <app-layout class="app-shell-body u-w-100">
        <div class="main-app-content-section" role="main">
          <app-dropdown-templates />
          <app-tooltip-global></app-tooltip-global>
          <router-outlet></router-outlet>
        </div>
        @if (quickSearch()?.trigger) {
          <div class="quick-list-section">
            <app-quick-search (onClose)="handleCloseQuickSearch()" />
          </div>
        }
        <app-alerts-marquee class="app-shell-bar">
          @if (clockWidget.enabled()) {
            <app-usa-timezone-clock />
          }
        </app-alerts-marquee>
      </app-layout>
      <app-my-reminders />
    </div>
    @if (laneListPopup()) {
      <app-popup [trigger]="laneListPopup()" heading="Lane Search" size="xxl"
        (handleClose)="laneListPopup.set(false)">
        <app-lane-list (loadClick)="openLoadFromLaneList($event)" />
      </app-popup>
    }
    <!-- Rendered last so a detail opened from another popup (e.g. Lane Search) stacks above it. -->
    @for (entry of assetStack(); track entry.key) {
      <app-popup [trigger]="true" [heading]="entry.heading"
        [size]="entry.assetType === 'load' ? 'xxl' : 'xl'" (handleClose)="closeAssetPopup(entry.key)">
        @defer (on immediate) {
        <app-overlay-loader [loading]="entry.loading()" minHeight="60vh">
          @switch (entry.assetType) {
            @case ('trailer') {
              <app-trailer-compact-detail [trailer]="entry" tabQueryParam="detailTab"
                (loadingChange)="entry.loading.set($event)" />
            }
            @case ('truck') {
              <app-truck-compact-detail [truck]="entry"
                (loadingChange)="entry.loading.set($event)" />
            }
            @case ('driver') {
              <app-driver-compact-detail [driver]="entry" tabQueryParam="detailTab"
                (loadingChange)="entry.loading.set($event)" />
            }
            @case ('customer') {
              <app-customer-compact-detail [customer]="entry"
                (loadingChange)="entry.loading.set($event)" />
            }
            @case ('load') {
              <app-load-details [loadIdInput]="entry.id" from="task-search"
                (loadingChange)="entry.loading.set($event)" />
            }
            @case ('dispatch') {
              <app-dispatch-details [dispatchId]="entry.id" />
            }
          }
        </app-overlay-loader>
        } @loading (minimum 300ms) {
        <app-overlay-loader [loading]="true" minHeight="45vh" />
        } @placeholder {
        <app-overlay-loader [loading]="true" minHeight="45vh" />
      }
    </app-popup>
  }
}
<div class="">
  <app-keyboard-shortcut [keys]="['ctrl', 'shift', 'x']" [url]="'workspace'" />
</div>
@if (isFloatingRoute()) {
  <app-dropdown-templates />
  <router-outlet></router-outlet>
}
}

@if (!isLoggedIn() && !isLoading()) {
  <app-auth-layout>
    <router-outlet></router-outlet>
  </app-auth-layout>
}
